import { performRequest } from "./nuxtApp.js";
import { clientOptions } from "#nuxt-graphql-middleware/client-options";
export function useGraphqlMutation(...args) {
  const [name, body, fetchOptions, overrideClientContext] = typeof args[0] === "string" ? [args[0], args[1], args[2]?.fetchOptions, args[2]?.clientContext] : [
    args[0].name,
    args[0].variables,
    args[0].fetchOptions,
    args[0].clientContext
  ];
  const globalClientContext = clientOptions && clientOptions.buildClientContext ? clientOptions.buildClientContext() : {};
  return performRequest(
    "mutation",
    name,
    body || {},
    fetchOptions || {},
    globalClientContext,
    overrideClientContext || {},
    {}
  );
}
